
import { size } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { emitter } from '../../../utils/emitter';
class ModalCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            categoryName: '',
            categoryCountry: '',
            categoryLevel: '',
            categoryParentId: ''
        }
        this.listenToEmitter();
    }
    listenToEmitter() {
        emitter.on('EVENT_CLEAR_MODAL_DATA', data => {
            this.setState({
                categoryName: '',
                categoryCountry: '',
                categoryLevel: '',
                categoryParentId: ''
            })
            console.log('emittet', data)
        });
    }
    componentDidMount() {
        // console.log('',)
    }
    toggle = () => {
        this.props.tooglefromParent()
    }
    handleOnchangeInput = (event, id) => {
        // bad code this.state[id] = event.target.value , ko nen update truc tiep
        // good code, thong qua 1 bien trung gian
        let copyState = { ...this.state }; // copy state moi
        copyState[id] = event.target.value
        this.setState({
            ...copyState
        }, () => { // callback function

        })
        // console.log("copyState: ", copyState)
        // console.log(event.target.value, id)
    }
    checkValideInput = () => {
        let arrInput = ['categoryName', 'categoryLevel', 'categoryParentId'];

        let isValide = true;
        for (let i = 0; i < arrInput.length; i++) { // neu dung vong lap MAP thi ko the dung break, foreach

            if (!this.state[arrInput[i]]) {
                isValide = false
                alert("Missing parameters" + arrInput[i]);
                break;
            }
        }
        return isValide
    }
    handleAddNewCategory = () => {
        let isValide = this.checkValideInput();
        if (isValide == true) {
            this.props.createNewCategory(this.state)
        }


        console.log("data modal: ", this.state)
    }

    render() {
        // console.log('check child props:', this.props);
        // console.log('check child open modal:', this.props.isOpen);
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                className="modal-category-container"
                size="lg"
                centered
            >
                <ModalHeader toggle={this.toggle}>Creating new Category</ModalHeader>
                <ModalBody>
                    <div className='modal-category-body'>

                        <div className='input-container'>
                            <label>Name: </label>
                            <input
                                type="text"
                                name="categoryName"
                                placeholder="Enter category name"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryName')
                                }}
                                value={this.state.Category}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Country: </label>
                            <select
                                name="categoryCountry"
                                id="categoryCountry"
                                class="form-control"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryCountry')
                                }}
                            >
                                <option selected>Choose Country</option>
                                {this.props.countries && this.props.countries.map((item, index) => {
                                    // console.log('check map', item, index);
                                    return (
                                        <option value={item.id}> {item.countryName} </option>

                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='modal-category-body'>
                        <div className='input-container'>
                            <label>Level: </label>
                            <input
                                type="text"
                                name="categoryLevel"
                                placeholder="Enter level"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryLevel')
                                }}
                                value={this.state.fullname}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Parent Id: </label>
                            <input
                                type="text"
                                name="categoryParentId"
                                placeholder="Enter currency"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'categoryParentId')
                                }}
                                value={this.state.address}
                            />
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button className='px-2' color="primary" onClick={this.handleAddNewCategory}>Add New</Button>{' '}
                    <Button className='px-2' color="secondary" onClick={this.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCategory);


